import { Button, Checkbox } from "@mantine/core";
import { useEffect, useState } from "react";
import { tableDataPropsPaymentBlock } from "../../../types/types";


export function TableDataPaymentBlock(props: tableDataPropsPaymentBlock){
 
  const [paymentEnabledBanks, setPaymentEnabledBanks] = useState<any>({});
  
  useEffect(() => {
    const method = () => {
      let initialValue: any = {};
      if(props.paymentBlocked && props.paymentBlocked.length > 0){
        props.paymentBlocked.forEach((obj) =>{
        initialValue['paymentBlock'] = true})
      }
      setPaymentEnabledBanks(initialValue);
    }
    method();
  }, [props.paymentBlocked]);

    return(
      <tr >
        <td>{props.dat.login_id}</td>
        <td>{props.dat.outlet_name}</td>
        <td>
        <Checkbox
            checked = {paymentEnabledBanks['paymentBlock']}
            onChange={(event) => {
              let copyOfPaymentEnabledBanks = {...paymentEnabledBanks};
              if(paymentEnabledBanks && paymentEnabledBanks['paymentBlock']) {
                copyOfPaymentEnabledBanks['paymentBlock'] = false;
              }
              else {
                copyOfPaymentEnabledBanks['paymentBlock'] = true;
              }
              setPaymentEnabledBanks(copyOfPaymentEnabledBanks);
            }}
          />
          </td>
            
        <td><Button style={{ backgroundColor: "#02BBd5" }}onClick={() => props.submitForm(paymentEnabledBanks, props.dat.login_id, props.dat.type)}>Submit</Button></td>
        
      </tr>
    
    )
}